// Is scanner enable
export const isScannerEnable = () => {
    const value = localStorage.getItem('scanner');
    return value === "true"
}